<template>
  <div class="no-signup-container">
    <span class="powered-logo">
      <PoweredByLogo />
    </span>
    <FriedButton
      data-external="no-signup-button"
      class="great-button"
      :button-type="ButtonType.Tertiary"
      @click="$emit('close')"
      >{{ $t('ok-great') }}</FriedButton
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ButtonType } from '@getaccept/fried-tofu';
import PoweredByLogo from '../../../assets/powered-by-ga.svg';

export default defineComponent({
  components: {
    PoweredByLogo,
  },
  setup() {
    return { ButtonType };
  },
});
</script>
<style lang="scss" scoped>
.no-signup-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: var(--spacing-150);
  justify-content: space-between;
  padding-top: 0;

  .great-button {
    width: 15rem;
    margin-top: $spacing-100;
  }
}
</style>
